/* Reviews pop-up (sections/bl-reviews): opens from [data-open-reviews], filters by length/photos, pages 10 at a time, relative dates. */
(() => {
  const dialog = document.getElementById('bl-reviews-dialog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = '1';
  let opener = null;
  const list = dialog.querySelector('.bl-rv__list');
  const items = [...dialog.querySelectorAll('.bl-rv__item')];
  const empty = dialog.querySelector('.bl-rv__empty');

  // Newest first, then relative dates ("2 days ago") so they never go stale in the markup.
  const day = 864e5;
  items.sort((a, b) => (b.dataset.posted || '').localeCompare(a.dataset.posted || '')).forEach(item => list.append(item));
  const ago = date => {
    const today = new Date(); today.setHours(12, 0, 0, 0);
    const days = Math.max(0, Math.round((today - date) / day));
    if (days < 1) return 'Today';
    if (days < 7) return days === 1 ? 'Yesterday' : `${days} days ago`;
    if (days < 30) { const w = Math.floor(days / 7); return `${w} week${w > 1 ? 's' : ''} ago`; }
    if (days < 365) { const m = Math.floor(days / 30); return `${m} month${m > 1 ? 's' : ''} ago`; }
    const y = Math.floor(days / 365); return `${y} year${y > 1 ? 's' : ''} ago`;
  };
  dialog.querySelectorAll('time[datetime]').forEach(time => {
    const date = Date.parse(`${time.dateTime}T12:00:00`);
    if (!Number.isNaN(date)) time.textContent = ago(date);
  });

  // Filter, then show PAGE at a time behind "Show more reviews".
  const PAGE = 10;
  const more = dialog.querySelector('[data-rv-more]');
  let key = 'all';
  let limit = PAGE;
  const matches = item => key === 'all' || (key === 'photos' ? item.hasAttribute('data-photo') : item.dataset.length === key);
  const render = () => {
    let shown = 0;
    let total = 0;
    items.forEach(item => {
      const match = matches(item);
      if (match) total += 1;
      item.hidden = !match || shown >= limit;
      if (match && shown < limit) shown += 1;
    });
    empty.hidden = total > 0;
    if (more) more.hidden = shown >= total;
  };
  render();

  const open = trigger => {
    opener = trigger;
    dialog.style.transform = '';
    dialog.showModal();
    document.documentElement.classList.add('bl-rv-open');
    trigger?.setAttribute('aria-expanded', 'true');
  };
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('bl-rv-open');
    opener?.setAttribute('aria-expanded', 'false');
    opener?.focus({preventScroll: true});
  });

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-reviews]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    if (!dialog.open) return;
    if (event.target.closest('[data-rv-close]')) { close(); return; }
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    }
    const filter = event.target.closest('[data-rv-filter]');
    if (filter && dialog.contains(filter)) {
      key = filter.dataset.rvFilter;
      limit = PAGE;
      dialog.querySelectorAll('[data-rv-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === filter)));
      render();
    }
    if (event.target.closest('[data-rv-more]')) { limit += PAGE; render(); }
  });

  // Swipe the sheet down by its handle to close it (mobile bottom sheet).
  const grab = dialog.querySelector('[data-rv-grab]');
  let startY = null;
  grab?.addEventListener('pointerdown', event => { startY = event.clientY; grab.setPointerCapture(event.pointerId); });
  grab?.addEventListener('pointermove', event => {
    if (startY === null) return;
    dialog.style.transform = `translateY(${Math.max(0, event.clientY - startY)}px)`;
  });
  const release = event => {
    if (startY === null) return;
    const moved = event.clientY - startY;
    startY = null;
    if (moved > 90) close(); else dialog.style.transform = '';
  };
  grab?.addEventListener('pointerup', release);
  grab?.addEventListener('pointercancel', release);
})();
